import { ItemView, util } from '@glu/core';
import SavedViewsModel from './savedViewsModel';

import template from './addNewView.hbs';

export default ItemView.extend({
  template,
  tagName: 'ul',
  className: 'item-list grid-add-new-view',

  ui: {
    $input: '.js-grid-save-view-input'
  },

  events: {
    'click .grid-save-view-btn': 'showSaveViewForm',
    'click .js-grid-save-view-cancel-btn': 'showSaveViewLink',
    'submit form': 'save'
  },

  showLink: true,

  initialize(options) {
    this.grid = options.grid;
    this.model = new SavedViewsModel(util.pick(this.grid.stateModel.toJSON(), 'name'));
    this.savedViewsCollection = options.savedViewsCollection;
  },

  templateHelpers() {
    return {
      showLink: this.showLink,
      isEmpty: this.savedViewsCollection.isEmpty(),
      cid: this.cid
    };
  },

  showSaveViewForm(e) {
    e.preventDefault();

    this.updateView(false);
    this.focus();
  },

  focus() {
    util.defer(() => {
      if (this.isClosed) {
        return;
      }

      this.ui.$input.focus();
    });
  },

  showSaveViewLink(e) {
    e.preventDefault();

    this.updateView(true);
  },

  updateView(updateFlag) {
    util.defer(() => {
      if (this.isClosed) {
        return;
      }
      this.showLink = updateFlag;
      this.render();
    });
  },

  save(e) {
    e.preventDefault();

    if (!this.model.isValid()) {
      return;
    }

    const id = this.grid.stateModel.get('id');

    if (this.model.get('name') === this.grid.stateModel.get('name') && id) {
      return this.updateSavedView(id);
    }

    this.saveNewView();
  },

  saveNewView() {
    // the current stateModel needs a way to be compared to saved views
    this.grid.stateModel.set({
      id: window.Date.now() // ensure that IDs are unique across sessions
    });

    this.updateSavedView();
  },

  updateSavedView(id) {
    const currentState = util.omit(this.grid.stateModel.toJSON(), ['name', 'default']);
    const isIdDefined = !util.isNullOrUndefined(id);

    this.model.set(currentState);

    this.savedViewsCollection.add(this.model, {
      merge: isIdDefined
    });

    // need to trigger add event manually after existing model update to save new values in the model
    if (isIdDefined) {
      this.savedViewsCollection.trigger('add', this.model);
    }
  }
});
